import { Field, FieldGrid, FieldSet, SelectField } from "../../components/Fields";
import { NavRow, RowGroup } from "../../components/Rows";
import { MAX_PREP_SECS } from "../../domain/queue";
import { useProfileForm } from "./profileForm";
import SettingsPage from "./SettingsPage";

/** How a session runs: which moves are in it, and the timings around them. */
export default function SessionSettings() {
  const { f, set, save, dirty } = useProfileForm();

  return (
    <SettingsPage
      title="Session settings"
      intro="Which moves a session holds, and the timings around them."
      onSave={() => void save()}
      dirty={dirty}
    >
      <RowGroup>
        <NavRow
          kind="toggle"
          title="Hip-safe mode"
          subtitle="On: no squats or lunges, and hip-sensitive moves carry a warning. Off: adds squats, reverse lunges and squat pulses."
          checked={f.hipSafe}
          onChange={(v) => set("hipSafe", v)}
        />
      </RowGroup>

      <FieldSet legend="Timings" hint="Rest at 0 uses the plan's own values, which shorten as the phases progress.">
        <FieldGrid>
          <Field
            label="Rest between moves"
            unit="s"
            type="number"
            step="5"
            min="0"
            value={f.restMove}
            onChange={(v) => set("restMove", v)}
          />
          <Field
            label="Rest between rounds"
            unit="s"
            type="number"
            step="5"
            min="0"
            value={f.restRound}
            onChange={(v) => set("restRound", v)}
          />
        </FieldGrid>
        {/* Timed moves only — reps have no clock to be late for. */}
        <Field
          label="Get set before a timed move"
          unit="s"
          type="number"
          step="5"
          min="0"
          max={String(MAX_PREP_SECS)}
          value={f.prepSecs}
          onChange={(v) => set("prepSecs", v)}
          hint="Runs after Start, so you can be kneeling or lying down before the clock begins. 0 starts at once."
        />
      </FieldSet>

      <FieldSet
        legend="Plan"
        hint="Phase decides the doses. Auto steps through them from the start date — 1 in weeks 1–2, 2 in weeks 3–4, 3 from week 5; pin one to repeat it."
      >
        <FieldGrid>
          <Field
            label="Plan start date"
            type="date"
            value={f.startDate}
            onChange={(v) => set("startDate", v)}
          />
          <SelectField
            label="Phase"
            value={f.phaseMode}
            onChange={(v) => set("phaseMode", v)}
            options={[
              { value: "auto", label: "Auto" },
              { value: "0", label: "Phase 1" },
              { value: "1", label: "Phase 2" },
              { value: "2", label: "Phase 3" },
            ]}
          />
        </FieldGrid>
      </FieldSet>
    </SettingsPage>
  );
}
